import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-807bc976"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-loader__message" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Uploading files... ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.total) + " ", 1),
      _hoisted_4,
      _createTextVNode(" " + _toDisplayString(_ctx.errors) + " ", 1),
      _hoisted_5,
      _createTextVNode(" " + _toDisplayString(_ctx.upload) + " ", 1),
      _hoisted_6,
      _createTextVNode(" " + _toDisplayString(_ctx.uploadPercent), 1)
    ]),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelUpload && _ctx.cancelUpload(...args))),
      class: "cancel-btn"
    }, "Cancel upload")
  ]))
}